module.exports = __webpack_public_path__ + "static/media/blood-donation.436875cb.webp";